import type { PropsWithChildren, RefAttributes } from "react";
import type { DOMProps } from "../../types/dom";

export type DivElementType = HTMLDivElement;
export interface ContentProps
  extends DOMProps, RefAttributes<DivElementType>, PropsWithChildren {}

const Content = ({ ref, children, ...otherProps }: ContentProps) => (
  <div ref={ref} {...otherProps} className="mobius-modal__content">
    {children}
  </div>
);

Content.displayName = "Content";
export { Content };
